/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companyinformation1Inputs */

const en_companyinformation1 = /** @type {(inputs: Companyinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Information`)
};

const de_companyinformation1 = /** @type {(inputs: Companyinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensinformationen`)
};

/**
* | output |
* | --- |
* | "Company Information" |
*
* @param {Companyinformation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companyinformation1 = /** @type {((inputs?: Companyinformation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companyinformation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companyinformation1(inputs)
	return de_companyinformation1(inputs)
});
export { companyinformation1 as "companyInformation" }